import React, { useEffect, useRef, useState } from "react";
import PrimaryButton from "../components/Button/PrimaryButton";
import UploadButton from "../components/Button/UploadButton";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { DAO_DIGIO_URL, StaticRouterLinks } from "../utils/StaticRouterLinks";
import * as API from "../utils/service";
import { StaticAPI } from "../utils/StaticAPI";
import { isNullOrUndefined } from "../utils/utils";
import { toast } from "react-toastify";
import ErrorToster from "../components/TosterComponents/ErrorToster";
import { Checkbox, FormControlLabel } from "@mui/material";
import * as Constant from "../utils/constant";
import UploadImage from "../components/UploadImage";
import AccountClosureFileDialoge from "../components/DialogeComp/AccountClosureFileDialoge";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

export default function AccountClosing() {
  const { accountOptionForm, clientDetails, setOpen, setDialogContent } =
    useOutletContext();
  const fields = [
    { label: "Name", key: "Name" },
    { label: "Email", key: "Email" },
    { label: "Mobile", key: "Mobile Number" },
    { label: "Pan", key: "Pan" },
    { label: "BO Id", key: "BO Id" },
    { label: "Client Id", key: "Client Id" },
    { label: "DP ID", key: "DP Id" },
    { label: "Address", key: "Address" },
    { label: "Pin Code", key: "Pin Code" },
  ];

  const [loading, setLoading] = useState(false);
  const intervalID = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const handleTradingOption = (event) => {
    const name = event.target.name;
    const checked = event.target.checked;
    accountOptionForm.setFieldValue(`${[name]}`, checked);
  };

  const handleUpload = () => {
    setOpen(true);
    setDialogContent(
      <AccountClosureFileDialoge
        formikState={accountOptionForm}
        isCmr={
          accountOptionForm?.values?.balanceRemaining ===
            "Partly rematerialised and party transfered".trim() ||
          accountOptionForm?.values?.balanceRemaining ===
            "Transferred to another account (Number given below)".trim()
        }
      />
    );
  };

  const handleSelectChange = (event) => {
    accountOptionForm?.setFieldValue("balanceRemaining", event.target.value);
  };
  return (
    <>
      <div className="flex flex-col gap-5 min-w-[446px] max-w-[600px] mt-[74px] px-4 md:px-[54px] py-3 md:py-11 border md:border-pkt-rgba-220-218-225-0.50 rounded-lg drop-shadow-lg bg-white z-10">
        <table className="table-auto w-full rounded-lg border-separate border-gray-300 text-left text-sm md:text-base">
          <tbody className="">
            {fields.map((field) => (
              <tr key={field.key}>
                <th className="rounded-l border border-gray-300 px-2 py-1 font-medium">
                  {field.label}
                </th>
                <td
                  className={`rounded-r border border-gray-300 px-2 py-1 ${
                    field.key === "Address" ? "max-w-[300px] break-words" : ""
                  }`}
                >
                  {clientDetails?.[field.key]}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <form
          onSubmit={accountOptionForm.handleSubmit}
          className="flex flex-col gap-5 border border-gray-300 rounded-lg p-4"
        >
          <span className="text-center">
            Do you want to close following accounts?
          </span>

          <div className="flex flex-wrap gap-5">
            <div className="flex flex-col gap-[14px] w-full ">
              {Constant.TRADING_OPTION?.map((lists, index) => {
                return (
                  <FormControlLabel
                    key={index}
                    sx={{
                      // flexDirection: "column",
                      justifyContent: "start",
                      alignItems: "center",
                      gap: "16px",
                      width: "100%",
                      margin: "0",
                      padding: "10px 8px",
                      border: "1px solid #EAEAEA",
                      borderRadius: "8px",
                    }}
                    control={
                      <Checkbox
                        checked={accountOptionForm.values[lists?.name]}
                        onChange={handleTradingOption}
                        name={lists?.name}
                        sx={{
                          padding: "3px 0 0 0",
                          color: "#2795BF",
                        }}
                      />
                    }
                    label={
                      <div className="flex  gap-3">
                        <p className="flex flex-row items-center gap-1 text-sm font-semibold text-pkt-primary">
                          {lists?.heading}
                        </p>
                      </div>
                    }
                  />
                );
              })}
            </div>
            <TextField
              id="outlined-basic"
              label="Reason for Closing the Account"
              variant="outlined"
              name="reason"
              sx={{ width: "100%" }}
              value={accountOptionForm?.values?.reason}
              onChange={accountOptionForm?.handleChange}
            />

            {!isNullOrUndefined(accountOptionForm.errors.selectSegment) && (
              <span className="errorTextField">
                {accountOptionForm.errors.selectSegment}
              </span>
            )}
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Balance remaining in the account (if any) to be.
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={accountOptionForm?.values?.balanceRemaining}
                label=" Balance remaining in the account (if any) to be."
                onChange={handleSelectChange}
              >
                <MenuItem
                  value={"Partly rematerialised and party transfered".trim()}
                >
                  Partly rematerialised and party transfered
                </MenuItem>
                <MenuItem value={"Rematerialised".trim()}>
                  Rematerialised
                </MenuItem>
                <MenuItem
                  value={"Transferred to another account (Number given below)".trim()}
                >
                  Transferred to another account (Number given below)
                </MenuItem>
                <MenuItem value={"Not applicable".trim()}>
                  Not applicable
                </MenuItem>
              </Select>
            </FormControl>

            {[
              "Partly rematerialised and party transfered",
              "Transferred to another account (Number given below)",
            ].includes(accountOptionForm?.values?.balanceRemaining) && (
              <div className="flex flex-col justify-between gap-2 w-full">
                <TextField
                  id="outlined-basic"
                  label="Target DP ID"
                  variant="outlined"
                  name="target_dp_id"
                  value={accountOptionForm?.values?.target_dp_id}
                  onChange={(event) => {
                    const value = event.target.value.replace(/\D/g, "");
                    if (value.length <= 8) {
                      accountOptionForm.setFieldValue("target_dp_id", value);
                    }
                  }}
                  inputProps={{ maxLength: 8, inputMode: "numeric" }}
                />
                <TextField
                  id="outlined-basic"
                  label="Target BO ID"
                  variant="outlined"
                  name="target_bo_id"
                  value={accountOptionForm?.values?.target_bo_id}
                  onChange={(event) => {
                    const value = event.target.value.replace(/\D/g, "");
                    if (value.length <= 8) {
                      accountOptionForm.setFieldValue("target_bo_id", value);
                    }
                  }}
                  inputProps={{ maxLength: 8, inputMode: "numeric" }}
                />
              </div>
            )}
          </div>

          <PrimaryButton
            size={"large"}
            name={"Upload Documents"}
            height={"50px"}
            borderRadius={"10px"}
            handleOnClick={handleUpload}
            isDisabled={
              !(
                (accountOptionForm?.values?.close_trading_account ||
                  accountOptionForm?.values?.close_demat_account) &&
                accountOptionForm?.values?.balanceRemaining && // Ensure balanceRemaining is not null/undefined
                ([
                  "Partly rematerialised and party transfered",
                  "Transferred to another account (Number given below)",
                ].includes(accountOptionForm?.values?.balanceRemaining)
                  ? accountOptionForm?.values?.target_dp_id?.length === 8 &&
                    accountOptionForm?.values?.target_bo_id?.length === 8
                  : true)
              )
            }
            loading={loading}
          />
        </form>
      </div>
    </>
  );
}
